<template>
  <div class="invoice-form-footer">
    <invoice-form-notes
      :notes="this.form.notes"
    />
    <invoice-form-summary
      :form="this.form"
      :subtotal="this.subtotal"
      :tax="this.tax"
      :total="this.total"
    />
  </div>
</template>

<script>
import InvoiceFormNotes from './InvoiceFormNotes.vue'
import InvoiceFormSummary from './InvoiceFormSummary.vue'

export default {
  name: 'InvoiceFormFooter',
  components: {
    InvoiceFormNotes,
    InvoiceFormSummary
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    subtotal: {
      type: Number
    },
    tax: {
      type: Number,
      default: 0
    },
    total: {
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-form-footer {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
@media (min-width: 768px) {
  .invoice-form-footer {
    flex-direction: row;
    > div:first-child {
      margin-right: 15px;
    }
  }
}
</style>
